/**
 * @author: ritesh.dabral
 * 
 * This page includes constants for action types
 */

 export const UPDATE_WHOLE_HOTSPOT_MAP_OBJECT = 'UPDATE_WHOLE_HOTSPOT_MAP_OBJECT';